module.exports = __webpack_public_path__ + "img/album21_07.7b962860.jpg";